import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { PagedResults, PagingParams } from '@abaco/web-common/src/Paging';
import { ProtocolActivityResourceOut } from '../models/Activity';
import { Adveristy, SeedType, SeedOut, Seed, SeedActionOut, SeedAction } from '../models/Seed';
import { copyUnitMeasure } from '../models/Product';
import { toHA } from '../models/Utils';

export default class SeedApi {

    private http: HTTPClient;
    private rootPath: string;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath
    }

    public async getSeedTypes(pk_cuaa: number, paging: PagingParams, filter: string | null): Promise<PagedResults<SeedType>> {
        const res = await this.http.get(`${this.rootPath}/v1/warehouse/subjects/${pk_cuaa}/seeds`, {
            params: {
                offset: paging.offset,
                count: paging.count,
                filter: filter ? `^item_name like ${filter.toUpperCase()}` : undefined
            }
        })

        return res.data;
    }

    public async getSeedType(pk_cuaa: number, item_id: number): Promise<SeedType> {
        const res = await this.http.get(`${this.rootPath}/v1/warehouse/subjects/${pk_cuaa}/seeds/${item_id}`)

        return res.data;
    }

    public async getAdversities(): Promise<Adveristy[]> {
        const res = await this.http.get(`${this.rootPath}/v1/plots/dictionary_adversity`, {
            params: {
                offset: 0,
                count: 300
            }
        })

        return res.data.records
    }

    public async editSeed(plot_id: number, action_id: number, action_resource_id: number, editedSeed: SeedOut): Promise<Seed> {
        const res = await this.http.put(`${this.rootPath}/v1/plots/plots/${plot_id}/activities/${action_id}/seed/${action_resource_id}`, editedSeed);
        copyUnitMeasure([res.data], "sco_unit_measure", "unit_measure")
        return res.data;
    }

    public async editProtocolSeed(pkCuaa: number, protocol_id: number, action_id: number, action_resource_id: number, editedSeed: ProtocolActivityResourceOut): Promise<Seed> {
        const res = await this.http.put(`${this.rootPath}/v1/protocols/subjects/${pkCuaa}/dictionary_protocols/${protocol_id}/activities/${action_id}/seed/${action_resource_id}`, editedSeed);
        copyUnitMeasure([res.data], "sco_unit_measure", "unit_measure")
        return res.data;
    }

    public async addSeed(plot_id: number, action_id: number, newSeed: SeedOut): Promise<Seed> {
        const res = await this.http.post(`${this.rootPath}/v1/plots/plots/${plot_id}/activities/${action_id}/seed`, newSeed);
        copyUnitMeasure([res.data], "sco_unit_measure", "unit_measure")
        return res.data;
    }

    public async addProtocolSeed(pkCuaa: number, protocol_id: number, action_id: number, newSeed: SeedOut): Promise<Seed> {
        const res = await this.http.post(`${this.rootPath}/v1/protocols/subjects/${pkCuaa}/dictionary_protocols/${protocol_id}/activities/${action_id}/seed`, newSeed);
        copyUnitMeasure([res.data], "sco_unit_measure", "unit_measure")
        return res.data;
    }


    public async deleteSeed(plot_id: number, action_id: number, action_resource_id: number): Promise<Seed> {
        const res = await this.http.delete(`${this.rootPath}/v1/plots/plots/${plot_id}/activities/${action_id}/seed/${action_resource_id}`);
        copyUnitMeasure([res.data], "sco_unit_measure", "unit_measure")
        return res.data;
    }

    public async deleteProtocolSeed(pkCuaa: number, protocol_id: number, action_id: number, action_resource_id: number): Promise<Seed> {
        const res = await this.http.delete(`${this.rootPath}/v1/protocols/subjects/${pkCuaa}/dictionary_protocols/${protocol_id}/activities/${action_id}/seed/${action_resource_id}`);
        copyUnitMeasure([res.data], "sco_unit_measure", "unit_measure")
        return res.data;
    }

    public async addActionSeed(pk_cuaa: number, campaign: number, execution_id: number, newSeed: SeedActionOut): Promise<SeedAction> {
        const res = await this.http.post(`${this.rootPath}/v1/plots/subjects/${pk_cuaa}/${campaign}/actions/${execution_id}/seed`, newSeed);
        toHA(res.data, ['area_covered']);
        copyUnitMeasure([res.data], "sco_unit_measure", "unit_measure")
        return res.data;
    }
    public async editActionSeed(pk_cuaa: number, campaign: number, execution_id: number, execution_resource_id: number, editedSeed: SeedActionOut): Promise<SeedAction> {
        const res = await this.http.put(`${this.rootPath}/v1/plots/subjects/${pk_cuaa}/${campaign}/actions/${execution_id}/seed/${execution_resource_id}`, editedSeed);
        copyUnitMeasure([res.data], "sco_unit_measure", "unit_measure")
        return res.data;
    }

    public async deleteActionSeed(pk_cuaa: number, campaign: number, execution_id: number, execution_resource_id: number): Promise<SeedAction> {
        const res = await this.http.delete(`${this.rootPath}/v1/plots/subjects/${pk_cuaa}/${campaign}/actions/${execution_id}/seed/${execution_resource_id}`);
        return res.data;
    }
}
